import { render } from "./ResizeHandler.vue?vue&type=template&id=1c2a68d0&scoped=true&ts=true"
import script from "./ResizeHandler.vue?vue&type=script&lang=ts"
export * from "./ResizeHandler.vue?vue&type=script&lang=ts"

import "./ResizeHandler.vue?vue&type=style&index=0&id=1c2a68d0&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2a68d0"]])

export default __exports__